import React, {Fragment} from 'react';
import DataflowBuilderList from './list';

const DataflowBuilder = (props) =>
  <Fragment>
    <Fragment>
      <DataflowBuilderList {...props}/>
    </Fragment>
  </Fragment>;

export default DataflowBuilder;
